export const processMarkdown = (markdown: string) => {
    // Limit heading levels

    const limitedHeadings = markdown?.replace(/^(#{2,})(\s)/gm, '###### ')
        ?.replace(/^(#{1,})(\s)/gm, '###### ')
        ?.replace(/^(#{3,})(\s)/gm, '###### ');

    // Preserve paragraph breaks by replacing double newlines first
    const preservedParagraphs = limitedHeadings?.replace(/\n\n/g, '\n\n  \n');

    // Add two spaces before single newlines to ensure line breaks
    const formattedMarkdown = preservedParagraphs?.replace(/\n(?!\n)/g, '  \n');

    return formattedMarkdown;
}

export const processMarkdown2 = (markdown: string) => {
  if (!markdown) return '';

  // Limit heading levels to h6
  const limitedHeadings = markdown.replace(/^#{1,6}(\s)/gm, '###### ');

  // Convert double newlines to <br/><br/> for paragraph breaks
  const withParagraphs = limitedHeadings.replace(/\n{2,}/g, '<br/><br/>');

  // Convert single newlines to <br/>
  const withLineBreaks = withParagraphs.replace(/\n/g, '<br/>');

  return withLineBreaks;
};
